export const ACTION_PREFIX = 'MODULE/OPTION'
